module.exports = __webpack_public_path__ + "static/media/Ruturaj Patil - Resume.4b2fc32b.pdf";